import { createGlobalStyle } from "styled-components";
import  theme from "@/styles/theme";

const GlobalStyle = createGlobalStyle`
  html,
  body {
    padding: 0;
    margin: 0;
    font-family: ${theme.fontFamily.default};
    font-weight:normal;
    font-size:16px;
    width:100%;
    min-height:100vh;
    background:${theme.background.muted}
  }

  body {
    background:transparent;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
  }
`;

export default GlobalStyle;
